export default __webpack_public_path__ + "static/media/322.f43fc683.png";